import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative space-y-6 lg:space-y-8 px-3 sm:px-4 lg:px-8 min-h-[calc(100vh-8rem)] pt-6" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-50 text-red-600 p-4 rounded-xl border border-red-200"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200/50 dark:border-slate-700/50 overflow-hidden"
}
const _hoisted_4 = { class: "hidden lg:block overflow-x-auto" }
const _hoisted_5 = { class: "min-w-full divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_6 = { class: "divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "px-6 py-4 text-sm font-medium text-slate-700 dark:text-slate-300" }
const _hoisted_9 = { class: "px-6 py-4 text-sm text-slate-500 dark:text-slate-400 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-4" }
const _hoisted_11 = { class: "px-6 py-4" }
const _hoisted_12 = { class: "flex gap-2 justify-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "lg:hidden divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_16 = {
  key: 0,
  class: "p-8 flex justify-center"
}
const _hoisted_17 = {
  key: 1,
  class: "px-6 py-12 text-center text-slate-500"
}
const _hoisted_18 = { class: "text-sm font-medium text-slate-700 dark:text-slate-300 mb-1" }
const _hoisted_19 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_20 = { class: "text-xs text-slate-500 dark:text-slate-400" }
const _hoisted_21 = { class: "flex gap-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 2,
  class: "card border border-gray-200/50 dark:border-gray-700/50 shadow-sm sticky bottom-0 z-30"
}
const _hoisted_25 = { class: "p-4" }
const _hoisted_26 = { class: "flex sm:items-center sm:justify-center min-h-screen sm:px-4 sm:pt-4 sm:pb-20 text-center" }
const _hoisted_27 = { class: "inline-block align-bottom sm:align-middle bg-white dark:bg-gray-800 sm:rounded-lg text-left overflow-hidden shadow-xl transform transition-all min-h-screen w-full fixed inset-x-0 top-0 sm:static sm:min-h-0 sm:max-w-4xl sm:w-full flex flex-col" }
const _hoisted_28 = { class: "bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 px-4 py-4 sm:px-6 flex items-center justify-between flex-shrink-0" }
const _hoisted_29 = { class: "text-lg font-bold text-white truncate" }
const _hoisted_30 = { class: "bg-white dark:bg-gray-800 px-3 pt-4 pb-3 sm:p-6 sm:pb-4 overflow-y-auto flex-1 max-h-[calc(100vh-12rem)]" }
const _hoisted_31 = { class: "text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2 truncate" }
const _hoisted_32 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 1,
  class: "text-center py-8 text-slate-500 border border-dashed rounded-xl"
}
const _hoisted_36 = { class: "text-sm mt-1" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "bg-gray-50 dark:bg-gray-700 px-4 py-3 flex flex-col gap-2 sm:px-6 sm:flex-row-reverse sm:gap-0 shrink-0" }
const _hoisted_39 = ["onClick"]

import { ref, computed, onMounted, watch } from 'vue'
import { Eye, Printer, FileText, Download as DownloadIcon, X, Loader2 } from 'lucide-vue-next'
import { completedFormService, type CompletedForm } from '@/services/completedFormService'
import TableControls from '@/components/layout/TableControls.vue'
import PaginationBar from '@/components/layout/PaginationBar.vue'
import TableLoader from '@/components/ui/TableLoader.vue'
import { useAuthStore } from '@/stores/auth'
import { useToast } from 'vue-toastification'

const toastTimeout = 5000


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeCompletedFormsView',
  setup(__props) {

const authStore = useAuthStore()
const toast = useToast()
const allForms = ref<CompletedForm[]>([])
const loading = ref(false)
const error = ref('')

const searchQuery = ref('')
const statusFilter = ref('')

const statusOptions = [
  { label: 'All', value: '' },
  { label: 'New', value: 'new' },
  { label: 'Read', value: 'read' },
  { label: 'Deleted', value: 'deleted' },
]

const showViewModal = ref(false)
const viewFormData = ref<CompletedForm | null>(null)

const viewFiles = computed(() => {
  if (viewFormData.value?.files && viewFormData.value.files.length > 0) {
    return viewFormData.value.files
  }
  if (viewFormData.value?.file_url) {
    return [{
      file_url: viewFormData.value.file_url,
      file_extension: viewFormData.value.file_extension || '',
      is_previewable: viewFormData.value.is_previewable || false,
    }]
  }
  return []
})

const forms = computed(() => {
  const uid = authStore.currentUser?.id
  if (!uid) return []
  return allForms.value.filter(f => Number(f.user_id) === uid)
})

const statusFiltered = computed(() => {
  if (!statusFilter.value) return forms.value
  return forms.value.filter(f => f.status === statusFilter.value)
})

const searchFiltered = computed(() => {
  if (!searchQuery.value.trim()) return statusFiltered.value
  const q = searchQuery.value.toLowerCase()
  return statusFiltered.value.filter(f =>
    (f.form_subject || '').toLowerCase().includes(q)
  )
})

const perPage = ref(10)
const currentPage = ref(1)
const filteredTotalPages = computed(() => Math.max(1, Math.ceil(searchFiltered.value.length / perPage.value)))
const filteredTotal = computed(() => searchFiltered.value.length)

const paginatedForms = computed(() => {
  const start = (currentPage.value - 1) * perPage.value
  const end = start + perPage.value
  return searchFiltered.value.slice(start, end)
})

watch([statusFilter, searchQuery, perPage], () => {
  currentPage.value = 1
})

const goToPage = (page: number) => {
  currentPage.value = page
}

const formatDate = (date?: string) => {
  if (!date) return '—'
  const d = new Date(date)
  const opts: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
  return d.toLocaleDateString('en-US', opts) + ' [' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) + ']'
}

const typeClass = (type?: string) => {
  switch (type) {
    case 'Doc File': return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
    case 'Online form': return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
    case 'URL Link': return 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300'
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300'
  }
}

const viewForm = (form: CompletedForm) => {
  viewFormData.value = form
  showViewModal.value = true
}

const handleDownload = async (file: { download_url?: string; file_name?: string }) => {
  const url = file.download_url
  if (!url) return
  try {
    const token = localStorage.getItem('token')
    const response = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    if (!response.ok) throw new Error('Download failed')
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = file.file_name || 'download'
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(blobUrl)
    document.body.removeChild(a)
  } catch {
    if (file.download_url) {
      window.open(file.download_url, '_blank')
    }
  }
}

const printForm = async (form: CompletedForm | null) => {
  if (!form) return
  if (form.form_content) {
    const win = window.open('', '_blank')
    if (!win) return
    win.document.write('<html><head><title>' + (form.form_subject || 'Form') + '</title>')
    win.document.write('<style>body { padding: 20px; font-family: Arial, sans-serif; }</style>')
    win.document.write('</head><body>')
    win.document.write(form.form_content)
    win.document.write('</body></html>')
    win.document.close()
    win.print()
    toast.success('Document printed successfully', { timeout: toastTimeout })
  } else if (form.files?.length) {
    const loadingToast = toast.info('Preparing document for printing...', { timeout: false })
    let downloadUrl = form.files[0].download_url
    if (!downloadUrl) {
      downloadUrl = completedFormService.getDownloadUrl(form.form_id as any)
    }
    try {
      await completedFormService.printFile(downloadUrl)
      toast.dismiss(loadingToast)
      toast.success('Document printed successfully', { timeout: toastTimeout })
    } catch (err: any) {
      toast.dismiss(loadingToast)
      toast.error(err.message || 'Failed to print file', { timeout: toastTimeout })
    }
  }
}

const fetchForms = async () => {
  loading.value = true
  error.value = ''
  try {
    allForms.value = await completedFormService.fetchAll()
  } catch (err: any) {
    error.value = 'Failed to load completed forms.'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchForms()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" }, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", { class: "text-2xl sm:text-3xl lg:text-4xl font-bold text-primary dark:text-secondary" }, " My Completed Forms "),
        _createElementVNode("p", { class: "text-sm text-slate-500 dark:text-slate-200 mt-2" }, " View forms you have submitted. ")
      ])
    ], -1)),
    _createVNode(TableControls, {
      search: searchQuery.value,
      "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
      status: statusFilter.value,
      "onUpdate:status": _cache[1] || (_cache[1] = ($event: any) => ((statusFilter).value = $event)),
      perPage: perPage.value,
      "onUpdate:perPage": _cache[2] || (_cache[2] = ($event: any) => ((perPage).value = $event)),
      options: statusOptions,
      filterLabel: "Status",
      placeholder: "Search by subject...",
      class: "md:sticky md:top-[80px]"
    }, null, 8, ["search", "status", "perPage"]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("thead", { class: "bg-slate-50 dark:bg-slate-800/50" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Form Name"),
                  _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Date Submitted"),
                  _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Type"),
                  _createElementVNode("th", { class: "px-6 py-4 text-center text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Action")
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_6, [
                (loading.value)
                  ? (_openBlock(), _createBlock(TableLoader, {
                      key: 0,
                      colspan: 4,
                      title: "Fetching Forms"
                    }))
                  : (paginatedForms.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("td", {
                          colspan: "4",
                          class: "px-6 py-12 text-center text-slate-500"
                        }, "No completed forms found.", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedForms.value, (form) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: form.form_id,
                    class: "hover:bg-slate-50 dark:hover:bg-slate-800/50"
                  }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(form.form_subject || '—'), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(formatDate(form.date_sent)), 1),
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-2.5 py-1 text-xs font-semibold rounded-full", typeClass(form.type)])
                      }, _toDisplayString(form.type || '—'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (viewForm(form)),
                          class: "p-2 text-blue-600 hover:bg-primary/10 rounded-lg transition-colors",
                          title: "View"
                        }, [
                          _createVNode(_unref(Eye), { class: "w-5 h-5" })
                        ], 8, _hoisted_13),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (printForm(form)),
                          class: "p-2 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors",
                          title: "Print"
                        }, [
                          _createVNode(_unref(Printer), { class: "w-5 h-5" })
                        ], 8, _hoisted_14)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_unref(Loader2), { class: "w-8 h-8 animate-spin text-primary" })
                ]))
              : (paginatedForms.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, "No completed forms found."))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paginatedForms.value, (form) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: form.form_id,
                      class: "p-4 hover:bg-slate-50 dark:hover:bg-slate-800/50"
                    }, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(form.form_subject || '—'), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2 py-1 text-xs font-semibold rounded-full", typeClass(form.type)])
                        }, _toDisplayString(form.type || '—'), 3),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(formatDate(form.date_sent)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (viewForm(form)),
                          class: "p-2 text-blue-600 hover:bg-primary/10 rounded-lg transition-colors",
                          title: "View"
                        }, [
                          _createVNode(_unref(Eye), { class: "w-5 h-5" })
                        ], 8, _hoisted_22),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (printForm(form)),
                          class: "p-2 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors",
                          title: "Print"
                        }, [
                          _createVNode(_unref(Printer), { class: "w-5 h-5" })
                        ], 8, _hoisted_23)
                      ])
                    ]))
                  }), 128))
          ])
        ])),
    (!loading.value && !error.value && filteredTotal.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(PaginationBar, {
              "current-page": currentPage.value,
              "total-pages": filteredTotalPages.value,
              total: filteredTotal.value,
              "per-page": perPage.value,
              "onUpdate:page": goToPage
            }, null, 8, ["current-page", "total-pages", "total", "per-page"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showViewModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (showViewModal.value = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", {
                  class: "fixed inset-0 transition-opacity bg-black bg-opacity-50 dark:bg-opacity-50",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showViewModal.value = false))
                }),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("h3", _hoisted_29, _toDisplayString(viewFormData.value?.form_subject || 'Form Content'), 1),
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showViewModal.value = false)),
                      class: "shrink-0 p-1.5 rounded-lg hover:bg-white/10 text-white/80 hover:text-white transition-colors"
                    }, [
                      _createVNode(_unref(X), { class: "h-5 w-5" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    (viewFiles.value.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(viewFiles.value, (file, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "mb-5 last:mb-0"
                          }, [
                            _createElementVNode("p", _hoisted_31, _toDisplayString(file.file_name || `File ${i + 1}`), 1),
                            (file.is_previewable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  (['jpg','jpeg','png','gif','webp'].includes(file.file_extension))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: file.file_url,
                                        class: "max-w-full max-h-[70vh] rounded-lg"
                                      }, null, 8, _hoisted_33))
                                    : (file.file_extension === 'pdf')
                                      ? (_openBlock(), _createElementBlock("iframe", {
                                          key: 1,
                                          src: file.file_url,
                                          class: "w-full h-[70vh] rounded-lg"
                                        }, null, 8, _hoisted_34))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createVNode(_unref(FileText), { class: "h-12 w-12 mx-auto mb-2 text-slate-300 dark:text-slate-600" }),
                                  _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-base font-medium" }, "Preview not available", -1)),
                                  _createElementVNode("p", _hoisted_36, "(." + _toDisplayString(file.file_extension) + ")", 1)
                                ]))
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "form-content",
                          innerHTML: viewFormData.value?.form_content || 'No content available.'
                        }, null, 8, _hoisted_37))
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewFiles.value, (file, i) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: i,
                        onClick: ($event: any) => (handleDownload(file)),
                        class: "w-full sm:w-auto sm:ml-3 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-primary hover:bg-secondary shadow-sm transition-all inline-flex items-center justify-center gap-2"
                      }, [
                        _createVNode(_unref(DownloadIcon), { class: "h-4 w-4" }),
                        _createTextVNode(" Download File " + _toDisplayString(viewFiles.value.length > 1 ? i + 1 : ''), 1)
                      ], 8, _hoisted_39))
                    }), 128)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-secondary-text dark:text-secondary-dark-text hover:bg-gray-100/80 dark:hover:bg-gray-700/60 transition-colors",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showViewModal.value = false))
                    }, "Close")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})